import React from 'react'
import { DrawerWithState } from 'src/components/DrawerWithState'
import { DrawerWithStateProps } from 'src/components/DrawerWithState/types'
import {
  useAddAdminMutation,
  useDeleteAdminMutation,
  useEditAdminMutation,
  useLazyGetAdminQuery,
} from 'src/store/APIs/admins'

import { AddAdmin } from '../AddAdmin'
import { strings } from '../strings'
import { ViewAdmin } from '../ViewAdmin'

interface AdminDrawerProps extends Partial<DrawerWithStateProps> {
  open: boolean
  onCloseDrawer: () => void
  selectedId?: string
}

export const AdminDrawer: React.FC<AdminDrawerProps> = ({
  open,
  onCloseDrawer,
  selectedId,
}) => {
  const [triggerAddResourceMutation, { isLoading: isLoadingAdd }] =
    useAddAdminMutation()
  const [triggerEditResourceMutation, { isLoading: isLoadingEdit }] =
    useEditAdminMutation()
  const [triggerDeleteResourceMutation, { isLoading: isLoadingDelete }] =
    useDeleteAdminMutation()

  const isLoadingRightButton = isLoadingAdd || isLoadingEdit

  return (
    <DrawerWithState
      selectedId={selectedId}
      open={open}
      onClose={onCloseDrawer}
      resourceName={strings.resourceName}
      RenderAdd={AddAdmin}
      RenderView={ViewAdmin}
      useLazyGetResource={useLazyGetAdminQuery}
      onCloseDrawer={onCloseDrawer}
      triggerAddResourceMutation={triggerAddResourceMutation}
      triggerEditResourceMutation={triggerEditResourceMutation}
      isLoadingRightButton={isLoadingRightButton}
      triggerDeleteResourceMutation={triggerDeleteResourceMutation}
      isLoadingLeftButton={isLoadingDelete}
      deleteModalTitle={strings.deleteModalTitle}
    />
  )
}
